const normalizePitch = pitch => String(pitch || '')

export const getAvailableVideoWallPitches = ({ orlando = false } = {}) => {
  const pitches = orlando ? ['2.9', '4.8'] : ['1.9', '2.9', '4.8']
  return pitches
}

export const normalizeVideoWallPitch = ({ pitch, environment, orlando = false } = {}) => {
  const available = getAvailableVideoWallPitches({ environment, orlando })
  const current = normalizePitch(pitch)
  return available.includes(current) ? current : available[0]
}

export const getVideoWallRecommendation = ({
  content,
  environment,
  viewingDistance,
  orlando = false
} = {}) => {
  const detailedContent = content === 'presentation'

  if (environment === 'outdoor') {
    if (viewingDistance === 'far') {
      const recommendedPitch = orlando && !detailedContent ? '4.8mm' : '2.9mm'
      return `${recommendedPitch} is the practical outdoor choice beyond 20 meters. Viewers at this distance would not benefit from 1.9mm resolution; if 1.9mm is selected, the setup must comply with our outdoor-use policy.`
    }

    if (viewingDistance === 'close' || detailedContent) {
      return '2.9mm is the recommended outdoor-rated option for this setup. 1.9mm remains available only when the setup can comply with our outdoor-use policy.'
    }

    return '2.9mm is the recommended outdoor-rated option. 1.9mm remains available only when the setup can comply with our outdoor-use policy.'
  }

  if (viewingDistance === 'far') {
    if (orlando && !detailedContent) {
      return '4.8mm is the best-value option beyond 20 meters. Choose 2.9mm only when the content includes detailed text; 1.9mm adds no useful visible detail at this distance.'
    }

    return '2.9mm provides the appropriate detail beyond 20 meters. 1.9mm adds no useful visible detail at this distance.'
  }

  if (detailedContent || viewingDistance === 'close') {
    return '1.9mm gives the clearest text and close-up viewing. 2.9mm is the best value for most events.'
  }

  return null
}
